import React, { useEffect, useState, useCallback, memo } from "react";
import { Dropdown, Option } from "@fluentui/react-components";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

function ScopeSelector({ SCOPES = {}, selectedScope, onSelect, disabled }) {
  const { t } = useTranslation();
  // 🔹 Normalize SCOPES (object or array)
  const scopesArray = Array.isArray(SCOPES)
    ? SCOPES
    : Object.keys(SCOPES || {});
  const [value, setValue] = useState("");

  // ✅ Sync local state with external selectedScope (for edit mode)
  useEffect(() => {
    if (selectedScope && selectedScope !== value) {
      setValue(selectedScope);
    }
  }, [selectedScope, value]);

  // ✅ Stable selection handler
  const handleSelect = useCallback(
    (_, data) => {
      const newScope = data.optionValue;
      setValue(newScope);

      if (onSelect) {
        // prevent ResizeObserver warnings by delaying parent update
        setTimeout(() => onSelect(newScope), 0);
      }
    },
    [onSelect]
  );

  return (
    <Dropdown
      placeholder={t("SELECT_SCOPE")}
      value={selectedScope}
      onOptionSelect={handleSelect}
      appearance="outline"
      disabled={disabled}
      className="group-scope"
    >
      {scopesArray.map((scope) => (
        <Option key={scope} value={scope}>
          {scope}
        </Option>
      ))}
    </Dropdown>
  );
}

ScopeSelector.propTypes = {
  SCOPES: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  selectedScope: PropTypes.string,
  onSelect: PropTypes.func,
  disabled: PropTypes.bool,
};

// ✅ Skip re-render if scope didn't change
export default memo(ScopeSelector, (prev, next) => prev.selectedScope === next.selectedScope);
